export default __webpack_public_path__ + "static/media/delete-orange.2eb2f8a5.svg";